module.exports = __webpack_public_path__ + "static/media/qatar.32f15a2e.png";